module.exports = __webpack_public_path__ + "static/lo-lifes-right-5a49e4661f78b75e1387aed658d5ecf3.jpg";